import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { AboutPage } from './pages/AboutPage';
import { NotFoundPage } from './pages/NotFoundPage';

function App() {
  useEffect(() => {
    document.body.classList.add('grain-overlay');
    return () => document.body.classList.remove('grain-overlay');
  }, []);

  return (
    <div className="App min-h-screen bg-[#0D0D0D]">
      <BrowserRouter>
        {/* First focusable element on every page. Header is ~6 tab stops deep,
            so without this a keyboard user walks the whole nav on every route.
            focus:fixed keeps it out of flow, so revealing it shifts nothing. */}
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-5 focus:py-3 focus:rounded-lg focus:bg-[#17798A] focus:text-white focus:text-sm focus:font-bold focus:uppercase focus:tracking-widest"
        >
          Skip to content
        </a>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#151515',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.1)',
          },
        }}
      />
    </div>
  );
}

export default App;
